import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhotoProcessingManager = _resolveComponent("PhotoProcessingManager")!
  const _component_UploadLimitModalAlertComponent = _resolveComponent("UploadLimitModalAlertComponent")!
  const _component_DuplicateFilesModalComponent = _resolveComponent("DuplicateFilesModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      type: "file",
      id: "files-input-v3",
      class: "hidden",
      name: "images",
      multiple: "",
      accept: "image/*, video/*, .cr2, .raf, .cr3, .arw, .nef, .nrw, .dng",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectFiles && _ctx.selectFiles(...args))),
      ref: "photos-uploader-input"
    }, null, 544),
    _createVNode(_component_PhotoProcessingManager, {
      "photo-ids": _ctx.uploadedPhotoIds,
      enabled: _ctx.uploadedPhotoIds.length > 0,
      onProcessingComplete: _ctx.onProcessingComplete
    }, null, 8, ["photo-ids", "enabled", "onProcessingComplete"]),
    _createVNode(_component_UploadLimitModalAlertComponent, {
      open: _ctx.showUploadLimitModal,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showUploadLimitModal = false)),
      type: _ctx.limitUploadModalType
    }, null, 8, ["open", "type"]),
    _createVNode(_component_DuplicateFilesModalComponent, {
      open: _ctx.showDuplicatesModal,
      filesNames: _ctx.duplicateFileNames,
      onClose: () => {},
      onSkip: _cache[2] || (_cache[2] = ($event: any) => (_ctx.proceedWithPendingUpload(true))),
      onUploadBoth: _cache[3] || (_cache[3] = ($event: any) => (_ctx.proceedWithPendingUpload(false))),
      title: String(_ctx.$t('photo_uploader.duplicates_title')) || 'Знайдено файли з однаковою назвою',
      message: String(_ctx.$t('photo_uploader.duplicates_message')) || 'Деякі обрані файли вже існують у галереї. Оберіть дію:',
      skipText: String(_ctx.$t('photo_uploader.skip')) || 'Пропустити',
      uploadBothText: String(_ctx.$t('photo_uploader.upload_both')) || 'Завантажити обидва'
    }, null, 8, ["open", "filesNames", "title", "message", "skipText", "uploadBothText"])
  ], 64))
}